<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="'+INSTALLATIONS.INSTALLATION.PANEL.VENTILATION' | translate"
  [overlayType]="availableOverlays.Ventilation"
  [deviceSelectId]="deviceSelectId"
>
  <!-- ventilation.operating.modes.active -->
  <app-feature-tile
    *ngIf="ventilationMode$ | async | ready as feature"
    [attr.data-at-ventilation-operating-mode]="feature.properties?.value?.value"
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_MODE.TITLE' | translate"
    [value]="feature.properties?.value?.value | translateVentilationMode"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <!-- ventilation.operating.programs.active -->
  <ng-container feature *ngIf="ventilationState$ | async | ready as feature">
    <app-feature-tile
      *ngIf="
        listReasonToShowLevel.includes(feature.properties?.reason?.value) &&
        feature.properties?.level?.value !== VentilationOperatingPrograms.unknown
      "
      [attr.data-at-ventilation-operating-program]="feature.properties?.level?.value"
      [label]="'+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.TITLE' | translate"
      [value]="feature.properties?.level?.value | translateVentilationProgram"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
    <app-feature-tile
      *ngIf="!listReasonToShowLevel.includes(feature.properties?.reason?.value)"
      [attr.data-at-ventilation-operating-program]="feature.properties?.reason?.value"
      [label]="'+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.TITLE' | translate"
      [value]="feature.properties?.reason?.value | translateVentilationReason"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
  </ng-container>

  <ng-container feature *ngIf="ventilationBypassMode$ | async | ready as featureBypass">
    <app-feature-tile
      [attr.data-at-ventilation-bypass-state]="featureBypass.properties?.value.value"
      *ngIf="featureBypass.properties?.value.value === 'off'; else ventilationBypassPositionInfo"
      [label]="'+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.TITLE' | translate"
      [value]="featureBypass.properties?.value?.value | translateVentilationProgram"
      [attr.data-feature]="featureBypass.feature"
    >
    </app-feature-tile>

    <ng-template #ventilationBypassPositionInfo>
      <app-feature-tile
        [attr.data-at-ventilation-bypass-state]="
          (featureBypassPosition.properties?.value?.value > 0
            ? '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.ACTIVE'
            : '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.INACTIVE'
          ) | translate
        "
        *ngIf="ventilationBypassPosition$ | async | ready as featureBypassPosition"
        feature
        [label]="'+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.TITLE' | translate"
        [value]="
          (featureBypassPosition.properties?.value?.value > 0
            ? '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.ACTIVE'
            : '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_STATE.INACTIVE'
          ) | translate
        "
        [attr.data-feature]="featureBypassPosition.feature"
      >
      </app-feature-tile>
    </ng-template>
  </ng-container>

  <ng-container feature *ngFor="let device of remoteControllerDevices">
    <ng-container *ngrxLet="getLqiFeature(device.id) as feature">
      <app-feature-tile
        *ngrxLet="getDeviceDescription(device.id) as description"
        label="{{ device.modelId | moduleIdRemover }}"
        description="{{ description | value2: featurePropertyKey.name }}"
        value="{{ feature | value2: featurePropertyKey.strength }} {{
          feature | unit: featurePropertyKey.strength
        }}"
        [attr.data-feature]="feature?.feature"
        [error]="
          (feature | error) ||
          (feature?.properties?.strength &&
            feature?.properties?.strength?.value < lowLqiSignalThreshold)
        "
        [class.lqi-warning]="
          feature?.properties?.strength &&
          feature?.properties?.strength?.value < lowLqiSignalThreshold
        "
        [iconVariant]="iconVariant.error"
        informationTooltip="{{
          '+INSTALLATIONS.INSTALLATION.VITOTROL_LQI_STRENGTH.TOOLTIP' | translate
        }}"
        [showInformationTooltip]="
          feature?.properties?.strength &&
          feature?.properties?.strength?.value < lowLqiSignalThreshold
        "
      >
      </app-feature-tile>
    </ng-container>
  </ng-container>
</app-device-features-container>
